import { faker } from "@faker-js/faker";
import { PayoutMethod } from "kreate-common/modules/business-types";
import ButtonOutline from "kreate-common/modules/kreate-ui/components/ButtonOutline";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Input from "kreate-common/modules/kreate-ui/components/Input";
import Modal from "kreate-common/modules/kreate-ui/components/Modal";
import { httpPost$UpdateUser } from "kreate-server/commands/UpdateUser/fetcher";
import React from "react";
import { MdSend } from "react-icons/md";

import { shamelesslyRevalidateEverything } from "@/modules/common-utils/shamelesslyRevalidateEverything";

type Props = {
  open: boolean;
  onClose?: () => void;
  payoutMethods: PayoutMethod[];
};

export default function ModalPayoutAccount$Crypto$Add({
  open,
  onClose,

  payoutMethods,
}: Props) {
  const [busy, setBusy] = React.useState(false);
  const [chainName, setChainName] = React.useState("");
  const [tokenName, setTokenName] = React.useState("");
  const [address, setAddress] = React.useState("");

  const handleSubmit = async () => {
    setBusy(true);
    try {
      await httpPost$UpdateUser(`/api/v1/me/edit`, {
        payoutMethods: [
          ...payoutMethods,
          {
            type: "crypto",
            chainName,
            tokenName,
            address,
          },
        ],
      });
      await shamelesslyRevalidateEverything();
      onClose?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnDimmerClick={!busy}
      closeOnEscape={!busy}
    >
      <Modal.Header content="Crypto" />
      <Modal.Content>
        <Flex.Col gap="32px">
          <Input
            label="Chain name"
            value={chainName}
            onChange={setChainName}
            onDoubleClick={() =>
              chainName ||
              setChainName(faker.helpers.arrayElement(["Cardano", "Polygon"]))
            }
          />
          <Input
            label="Token name"
            value={tokenName}
            onChange={setTokenName}
            onDoubleClick={() => tokenName || setTokenName(faker.lorem.word())}
          />
          <Input
            label="Address"
            value={address}
            onChange={setAddress}
            onDoubleClick={() =>
              address || setAddress(faker.finance.ethereumAddress())
            }
          />
        </Flex.Col>
      </Modal.Content>
      <Modal.Actions>
        <ButtonOutline content="Cancel" onClick={onClose} disabled={busy} />
        <ButtonPrimary
          icon={<MdSend />}
          content="Add Payout Method"
          onClick={() => handleSubmit()}
          disabled={busy}
        />
      </Modal.Actions>
    </Modal>
  );
}
